import { useEffect } from "react";
import { pos, sessionTransport } from "@/platform";
import { useAuthUser } from "@/context/auth/AuthContext";
import { esSesionDeCaja } from "@/context/caja/sesionDeCaja";
import { useBffAxios } from "@/context/axios/AxiosContext";
import { prepareSession, renewSession } from "@/context/auth/sessionRenewal";
import {
  TIEMPO_MAXIMO_DEL_LOTE_MS,
  asegurarDrenador,
} from "@/context/caja/drenador";

/**
 * Sube la cola de la caja del negocio de la sesión (#338 AC-B). Sólo en el
 * escritorio: si el equipo no es una caja, no hay nada que tomar. La caja sin
 * sesión no sube: las ventas esperan a que alguien inicie sesión (#346, D8).
 */
export function useDrenadorDeLaCaja() {
  const user = useAuthUser();
  const businessId = esSesionDeCaja(user)
    ? undefined
    : (user?.businessId as string | undefined);
  const axios = useBffAxios();

  useEffect(() => {
    if (!pos.isAvailable) return;
    asegurarDrenador(businessId ?? null, {
      pos,
      enviar: (url, cuerpo) =>
        axios.post(url, cuerpo, { timeout: TIEMPO_MAXIMO_DEL_LOTE_MS }),
      renovarSesion: async () => {
        const sesion = await prepareSession(sessionTransport);
        if (!sesion.token) throw new Error("Sin sesión");
        await renewSession(sessionTransport, sesion);
      },
    });
  }, [businessId, axios]);
}
